import { crosstalkColumns } from '@ddv/models';

export function addCrosstalkcolumnsToSelectedColumns(selectedColumns: { columnId: string }[]): void {
    crosstalkColumns.forEach((column) => {
        if (!selectedColumns.some((c) => c.columnId === column.columnId)) {
            selectedColumns.push(column);
        }
    });
}
